define('viewmodels/site/logout',['lodash','dataSource/oemMessages','atn/atn'], function(_,oemMessages,atn) {
    'use strict';

    return {
        activate: activate,
        oemMessages:oemMessages.oemMessages,
        logoutMessages:atn.config.messages.logoutPage,
        capsProductName: atn.config.messages.general.capsProductName
    };

    function activate() {

    }
});
